import i18n from 'services/base/i18n';

export default {
  // Button to view the bandwidth data in the past hour
  hourly: () => i18n.pgettext('Pages|Device Information', 'HOURLY'),

  // Button to view the bandwidth data in the past day
  daily: () => i18n.pgettext('Pages|Device Information', 'DAILY'),

  // Button to view the bandwidth data in the past week
  weekly: () => i18n.pgettext('Pages|Device Information', 'WEEKLY'),

  // Label on the chart that tells the users what the violet line means (total upload)
  uploadLegendLabel: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'Upload'),

  // Label on the chart that tells the users what the blue line means (total download)
  downloadLegendLabel: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'Download'),

  // Total Upload/Download: Terabytes
  tb: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'TB'),
  // Total Upload/Download: Gigabytes
  gb: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'GB'),
  // Total Upload/Download: Gigabytes
  mb: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'MB'),
  // Total Upload/Download: Kilobytes
  kb: () => i18n.pgettext('Components|Bandwidth Usage Chart', 'KB'),
};
